export default __webpack_public_path__ + "static/media/arrow-down.276e143e.svg";